import { useEffect, useState } from "react";
import {
  DefaultApi,
  Language,
  CertArticlePreview,
  CertArticle,
} from "../adapters/api";

export const useCerts = (certId?: number) => {
  const defaultApi = new DefaultApi();
  const [certifications, setCertifications] = useState<CertArticlePreview[]>(
    []
  );
  const [compliances, setCompliances] = useState<CertArticlePreview[]>([]);

  const [accreditations, setAccreditations] = useState<CertArticlePreview[]>(
    []
  );

  const getCertsCertification = async (type: string, language: string): Promise<CertArticlePreview[]> =>
    new Promise((resolve, reject) => {
      defaultApi
        .getCertification(type, language as Language)
        .then((response) => {
          const { data } = response;
          setCertifications(data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });

  const getCertsById = async (certId: number, language: string): Promise<CertArticle> =>
    new Promise((resolve, reject) => {
      defaultApi
        .getCert(certId, language as Language)
        .then((response) => {
          const { data } = response;
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });

  return {
    getCertsCertification,
    getCertsById,
    certifications,
    accreditations,
    compliances,
  };
};
